import axios from "axios";
import { v4 as uuid } from "uuid";

// const baseURL = process.env.REACT_APP_APIURL;
const baseURL = "https://console.fbsedu.in/public"; 
// const baseURL = "http://localhost:8000/";

const Api = axios.create({
  baseURL,
  headers: {
    "Content-Type": "application/json",
    "Accept": "application/json",
    "Accept-Language": "en-us",
    "Access-Control-Allow-Origin": "*",
    "Platform-Type": "web",
  },
  timeout: 30000, 
});

const shouldSendToken = (url) => {
  const whitelist = ["/auth/login"]; 
  return !whitelist.some((endpoint) => url.endsWith(endpoint));
};

Api.interceptors.request.use(
  async (config) => {
    const uniqueId = uuid(); 
    config.headers["X-REQUEST-ID"] = uniqueId;

    return config;
  },
 // (error) => Promise.reject(error)
);

Api.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error("API call error:", error);
    return error;
  }
);

export default Api;